(ns common.schema.entities.kpi-category
  (:require [common.schema.schema-utils :as su]))

(def schema
  (concat [[:kpi-category/name {:field/data-type             :data.type/text-simple
                                :field/default-visibility    {:editor :editor.type/text-simple
                                                              :grid   :editor.type/text-simple
                                                              :field-visibility :in-use}
                                :field/lower-case-str?       true
                                :field/default-authorization su/access-user-ssg
                                :field/translations          {:en "Name"}}]
           ;;TODO currency
           [:kpi-category/email-title {:field/data-type             :data.type/text-simple
                                       :field/default-visibility    {:editor :editor.type/text-simple
                                                                     :grid   :editor.type/text-simple
                                                                     :field-visibility :in-use}
                                       :field/default-authorization {:access/read  :role/user
                                                                     :access/write :role/admin}
                                       :field/translations          {:en "Subject line"}}]
           [:kpi-category/email-copy {:field/translations          {:en "Message body"}
                                      :field/default-authorization {:access/read  :role/user
                                                                    :access/write :role/admin}
                                      :field/data-type             :data.type/text-richtext
                                      :field/default-visibility    {:editor :editor.type/wysiwyg
                                                                    :grid   :editor.type/wysiwyg
                                                                    :field-visibility :in-use}}]
           ;;TODO :kpi-category/currency,
           ;;  :kpi-category/kpis :kpi-category/questions
           ;;  :kpi-category/user-guidances, :kpi-category/ordering - not necessary in schema? or :editor/none?
           ]))
